import React from 'react';
import Loader from 'react-loader-spinner';

export default function loader() {
    return (
        <div>
            <br /><br /><br />
            <Loader
                type="ThreeDots"
                color="#00000"
                height="100"
                width="150" />
        </div>
    )
}




// WEBPACK FOOTER //
// ./src/components/loader.js